<template>
  <div>
    <person :model="model">
      <div class="row form-group">
        <w-datepicker class="col-6" :model="model.birthDate" />
      </div>
    </person>

    <div v-if="showDifferentAddressOption" class="row form-group">
      <yes-or-no class="col-12" :model="model.isDifferentAddress" />
    </div>

    <template v-if="showDifferentAddressFields">
      <div class="row form-group mt-3">
        <w-input class="col-12" :model="model.workName" />
      </div>

      <address-row :model="model.workAddress" />
    </template>

    <w-radio-list class="form-group mt-3" :model="model.profesion" :values="typeOfProfesion" />

    <div class="row form-group">
      <w-input class="col-6" :model="model.profesionName" />

      <yes-or-no class="col-6" :model="model.isOhp" />
    </div>

    <div class="row form-group">
      <w-datepicker class="col-4" :model="model.contractDate" />

      <w-datepicker class="col-4" :model="model.contractDataStart" />

      <w-datepicker class="col-4" position="bottom-left" :model="model.contractDataEnd" />
    </div>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';

import AddressRow from './Address';
import Person from './Person';
import YesOrNo from './YesOrNoRadio';

// @vuese
// Employee component
// @Group formComponents
export default {
  components: {
    AddressRow,
    Person,
    YesOrNo
  },
  mixins: [componentMixin],
  props: {
    // Typy profesji
    typeOfProfesion: { type: Array, required: true }
  },
  computed: {
    showDifferentAddressOption() {
      return !!this.model.isDifferentAddress && !this.model.isDifferentAddress.$disabled;
    },

    showDifferentAddressFields() {
      return this.showDifferentAddressOption && !!this.model.$model && !!this.model.$model.isDifferentAddress;
    }
  }
};
</script>
